import { _ } from "libs";

import React, { useContext, FC } from "react";
import moment from "moment-timezone";
import ReservationPageContext from "./reservationPageContext";
import CourtItemMedium from "../../items/court/medium";
import LoginButton from "./loginButton";

const SummaryUnauthenticated: FC = () => {
	const pageContext = useContext(ReservationPageContext);

	const {
		reservation,
		clubInfo,
		clearReservationContext,
		editing,
		onCloseClicked,
		onLoginButtonClicked,
	} = pageContext;
	const { params, court } = reservation;
	const { duration, startDateTime } = params;

	const timezone = clubInfo.timeZone;

	return (
		<div className="createReservation wizard">
			<div className="wizardHeader">
				<div
					className="close"
					onClick={() => (onCloseClicked ? onCloseClicked() : clearReservationContext())}
				/>
				<div className="title">
					{editing ? _("bookingWizard.editing.summary.heading") : _("bookingWizard.summary.heading")}
				</div>
			</div>
			<div className="wizardBody">
				<div className="bookingDate">
					{moment
						.unix(startDateTime)
						.tz(timezone)
						.format("dddd, MMMM D")}
				</div>
				<div className="bookingTime">
					{moment
						.unix(startDateTime)
						.tz(timezone)
						.format("H:mm")}
					{editing ? null : ", " + _("reservation.duration", duration, { duration })}
				</div>

				{court ? <CourtItemMedium court={court} extraClass="capsule" /> : null}
				<div style={{ marginTop: "24px" }}>
					<LoginButton onClick={onLoginButtonClicked} className="button secondaryButton fullWidth" />
				</div>
			</div>
		</div>
	);
};

export default SummaryUnauthenticated;
